import VerifyInvestorModal from "./verify-investor-modal";

export default VerifyInvestorModal;
